import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Header from 'components/Header';

const Input = (props) => {
  const {
    label,
    labelElement = null,
    labelClassName = '',
    id,
    value,
    onChange = () => {},
    onFocus = () => {},
    onClick = () => {},
    onRemove = null,
    removeHolder = false,
    placeholder = '',
    type = 'text',
    isTextVisible = true,
    errors = '',
    required = false,
    className = '',
    inputClassName = '',
    autoComplete = false,
    maxLength = 60,
    disabled = false,
    name = '',
    inputWrapperClassName = '',
    inlineElement = null,
    inputRef,
    asElement = false,
    showLabel = true,
    eyeClassName,
    parentComponent,
    ...componentProps
  } = props;

  const [textVisible, setTextVisible] = useState(false);
  const handleTextVisible = () => {
    setTextVisible(!textVisible);
  };

  return (
    <div className={`w-full ${className}`}>
      <Header
        labelClassName={labelClassName}
        id={id}
        label={label}
        labelElement={labelElement}
        errors={errors}
        required={required}
        showLabel={showLabel}
        parentComponent={parentComponent}
      />
      <div
        className={`relative flex gap-x-2 items-center ${inputWrapperClassName}`}
      >
        <input
          ref={inputRef}
          type={textVisible ? 'text' : type}
          placeholder={placeholder}
          id={id}
          name={name}
          className={`max-h-10 ${
            errors ? 'border-red' : 'border-default-border'
          }  outline-none border rounded w-full text-small ${
            disabled ? 'cursor-not-allowed opacity-60' : ''
          } ${asElement ? '' : 'px-4 py-3'} ${inputClassName}`}
          value={value || ''}
          onChange={onChange}
          autoComplete={autoComplete == true ? 'on' : 'off'}
          disabled={disabled}
          maxLength={maxLength}
          onFocus={onFocus}
          onClick={onClick}
          {...componentProps}
        />
        {inlineElement}
        {onRemove && (
          <i
            className="icon-error text-red w-5"
            aria-label="Remove item"
            onClick={() => onRemove(id)}
            onKeyPress={() => onRemove(id)}
            role="button"
            tabIndex={0}
          />
        )}
        {removeHolder && <i className="w-5" aria-label="Holder item" />}
        {!isTextVisible && (
          <i
            className={`absolute right-1 cursor-pointer fa-solid fa-eye ${eyeClassName}`}
            onClick={() => handleTextVisible()}
          ></i>
        )}
      </div>
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  labelElement: PropTypes.any,
  labelClassName: PropTypes.string,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  id: PropTypes.string,
  removeHolder: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  errors: PropTypes.string,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  autoComplete: PropTypes.bool,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  inputWrapperClassName: PropTypes.string,
  inlineElement: PropTypes.any,
  inputRef: PropTypes.any,
  asElement: PropTypes.bool,
  isTextVisible: PropTypes.bool,
  eyeClassName: PropTypes.string,
  parentComponent: PropTypes.string,
};

export default Input;
